import * as React from "react";
import Contact from "../components/Contact";
import Layout from "../components/Layout";
import Table from "../components/Table";
import TextBlock from "../components/TextBlock";
var Page = function Page() {
    return /*#__PURE__*/ React.createElement(Layout, {
        title: "ASN Registrations",
        description: ""
    }, /*#__PURE__*/ React.createElement(TextBlock, {
        background: "/images/bg-asn-registrations.jpg",
        backgroundColor: "#070b2c",
        color: "#ffffff",
        title: "ASN Registrations"
    }, "An AS Number (Autonomous System Number) or ASN is a unique number assigned by an RIR (Regional Internet Registry) such as RIPE, ARIN, APNIC.."), /*#__PURE__*/ React.createElement("div", {
        className: "container mx-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-3 gap-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "px-8 pb-24 col-span-3 md:col-span-2"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-5xl font-ibm font-bold py-10"
    }, "Benefits of having an ASN"), /*#__PURE__*/ React.createElement("ul", {
        className: "list-inside list-disc"
    }, /*#__PURE__*/ React.createElement("li", {
        className: "py-2"
    }, "Announce the IP Address Space using the BGP protocol"), /*#__PURE__*/ React.createElement("li", {
        className: "py-2"
    }, "Do Peering with Other Networks"), /*#__PURE__*/ React.createElement("li", {
        className: "py-2"
    }, "Much more"))), /*#__PURE__*/ React.createElement("div", {
        className: "col-span-3 md:col-span-1"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "text-5xl font-ibm font-bold py-10"
    }, "Pricing"), /*#__PURE__*/ React.createElement(Table, {
        title: "",
        head: ['Bits', 'Pricing'],
        data: [['32 Bits', '<strong> 150 € </strong> / year'], ['16 Bits', '<strong> 190 € </strong> / year']]
    })))), /*#__PURE__*/ React.createElement(Contact, null, "Do you have any ", /*#__PURE__*/ React.createElement("strong", null, "Questions"), "?. Do you need to ", /*#__PURE__*/ React.createElement("strong", null, "lease IPv4 addresses"), " with us?"));
};
export default Page;
